<template>
  <div>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <a
          :href="params.data.document"
          target="_blank"
          style="text-decoration: none"
          v-if="params.context.parentComponent.permissions.view"
        >
          <SecondaryButton
            x-small
            btnClass="mr-2 rounded"
            icon="mdi-eye"
            iconClass=""
            v-on="on"
            v-bind="attrs"
          >
          </SecondaryButton>
        </a>
      </template>
      <span>View Document</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <ErrorButton
          x-small
          v-on="on"
          v-bind="attrs"
          @click="deleteItem"
          v-if="params?.context?.parentComponent?.permissions?.delete"
          btnClass="mr-2 rounded"
          icon="mdi-delete"
          iconClass=""
        >
          mdi-delete
        </ErrorButton>
      </template>
      <span>Delete</span>
    </v-tooltip>
    <v-tooltip right>
      <template #activator="{ on, attrs }">
        <v-icon
          v-if="
            params.data.days_countdown > 0 && params.data.days_countdown <= 15
          "
          color="warning"
          v-on="on"
          v-bind="attrs"
        >
          mdi-information
        </v-icon>
        <v-icon
          v-else-if="params.data.days_countdown == 0"
          color="error"
          v-on="on"
          v-bind="attrs"
        >
          mdi-information
        </v-icon>
      </template>
      <span>{{ messageToDisplay(params.data.days_countdown) }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  methods: {
    deleteItem() {
      this.params.context.parentComponent.deleteItem(this.params.data.id);
    },
    messageToDisplay(daysLeft) {
      return daysLeft < 15 && daysLeft > 0
        ? `This document will expire in ${daysLeft} days`
        : "This Document has expired";
    },
  },
};
</script>
